/* eslint-disable prettier/prettier */
import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
  DailySummaryDto,
  SubstanceUsageType,
} from '@peartherapeutics/hylia-api-client';
import { SNAPSHOT_TEST } from 'utils/constants';
import styles from './styles.module.scss';

interface IBup {
  summary: DailySummaryDto;
}

const Bup = (props: IBup) => {
  const { summary } = props;

  const id = `bup-dot-${summary.date}`;
  const value =
    summary.medicationUse === SubstanceUsageType.Used
      ? 'Buprenorphine Use'
      : 'Buprenorphine Non-Use';

  if (summary.medicationUse !== SubstanceUsageType.NoData) {
    /** Flag turns off animations to enable stable snapshot testing */
    return (
      <>
        <div data-tip data-for={id} className={styles[summary.medicationUse]}>
          <div className={styles['text-hidden']}>{value}</div>
        </div>
        {!SNAPSHOT_TEST && (
          <ReactTooltip
            id={id}
            type="dark"
            place="bottom"
            effect="solid"
            className={styles.tooltip}
          >
            <span>{value}</span>
          </ReactTooltip>
        )}
      </>
    );
  }

  return null;
};

export default Bup;
